import { format, parse } from "date-fns";
import { fr } from "date-fns/locale";
import { Calendar as CalendarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export function DateField({ value, onChange, placeholder = "Choisir une date", testid }) {
  const selected = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" data-testid={testid}
          className="h-8 w-36 justify-start rounded-lg px-2 text-xs font-normal">
          <CalendarIcon size={13} className="mr-1.5 opacity-60" />
          {value ? format(selected, "dd MMM yyyy", { locale: fr }) : <span className="text-slate-400">{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={fr} selected={selected} defaultMonth={selected}
          onSelect={(d) => d && onChange(format(d, "yyyy-MM-dd"))} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
